/**
 * Product Delete Confirmation Dialog
 */

import { GenericDeleteDialog } from "@/components/ui/generic-delete-dialog";
import { Product } from "@/types/product";

interface ProductDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  product: Product | null;
  onConfirm: () => Promise<void>;
  isDeleting: boolean;
}

export function ProductDeleteDialog({
  open,
  onOpenChange,
  product,
  onConfirm,
  isDeleting,
}: ProductDeleteDialogProps) {
  const handleConfirm = async () => {
    await onConfirm();
    if (!isDeleting) {
      onOpenChange(false);
    }
  };

  return (
    <GenericDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      item={product}
      onConfirm={handleConfirm}
      isLoading={isDeleting}
      entityName="Produto"
      getItemLabel={(p) => p.nome}
    >
      <div className="space-y-3">
        <p>
          Você está prestes a excluir o produto{" "}
          <strong className="text-foreground">{product?.nome}</strong> do banco de dados.
        </p>
        <p className="text-destructive font-medium">
          ⚠️ Esta ação é PERMANENTE e não pode ser desfeita!
        </p>
        <p className="text-sm text-muted-foreground">
          💡 Se o produto estiver sendo usado em entradas de estoque ou receitas, a exclusão será bloqueada automaticamente.
        </p>
      </div>
    </GenericDeleteDialog>
  );
}
